<template>
    <main class="main" id="main">
        <div class="top_line">
            <div class="container">
                <h1>Личный кабинет - Реферальная программа</h1>
            </div>
        </div>

        <!----------Section LK------------->

        <section class="section s-lk">

            <div class="container">

                <div class="lk_box">

                    <navigate></navigate>

                    <div class="account_box" v-if="!auth.users.promocode">

                        <h1>Заработай с нами</h1>
                        <div class="chart_box">

                            <div class="referal_box">
                                <div class="earn_overlay">
                                    <h1>Прими участие в рефферальной программе.<br>
                                        Зарегистрируйся и зарабатывай вместе с нами!</h1>

                                    <router-link tag="button" to="/affiliate" class="menu_item_btn green" >ЗАРАБОТАТЬ</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="account_box" v-else>

                        <h1>Реферальный счет</h1>
                        <div class="referal_programm full">

                            <div class="referal_bonus">
                                <p>Вы накопили</p>
                                <h2>{{user.money}} рублей</h2>
                            </div>

                            <div class="withdrawal_request">
                                <p>Запросить перевод накопленных рублей</p>
                                <button class="menu_item_btn" @click="showModal('sendMoney')">Перевести рубли</button>
                            </div>
                        </div>
                        <div class="table_title">
                          <h1>История привлечений</h1>
                          <button type="button" @click="referralsToggle = !referralsToggle" :class="referralsToggle?'active choice_toggle':'choice_toggle'" id="referals_toggle"></button>
                        </div>
                        <div :class="referralsToggle?'active table_box':'table_box'" v-if="users" id="referal_table">
                            <table class="bonus_table">
                                <tr class="empty_row ">

                                </tr>

                                <tr class="bonus_row active">
                                    <th>Дата</th>
                                    <th>Время</th>
                                    <th>Пользователь</th>
                                </tr>

                                <tr class="bonus_row" v-for="(data, index) in users" :key="index">
                                    <td>{{data.date}}</td>
                                    <td>{{data.time}}</td>
                                    <td>{{data.source}}</td>
                                </tr>

                            </table>
                        </div>
                        <div class="referal_history empty" v-else>
                            <h2>Вы еще никого не пригласили</h2>
                        </div>

                        <h1>Сводная статистика</h1>
                        <div class="statistics_box">

                            <div class="statistic_row">
                                <span>Переходов по вашей ссылке</span>
                                <span>{{count}}</span>
                            </div>

                            <div class="statistic_row">
                                <span>Завершенных заказов</span>
                                <span>{{orders}}</span>
                            </div>

                            <div class="statistic_row">
                                <span>Заработано рублей</span>
                                <span>{{sum}} руб</span>
                            </div>

                        </div>

                        <div class="table_title">
                            <h1>Получено и потрачено</h1>
                            <button type="button" @click="bonusToggle = !bonusToggle" :class="bonusToggle?'active choice_toggle':'choice_toggle'" id="bonus_toggle"></button>
                        </div>

                        <div :class="bonusToggle?'active table_box':'table_box'" id="bonus_table" v-if="log">
                            <table class="bonus_table">
                                <tr class="empty_row ">

                                </tr>

                                <tr class="bonus_row active">
                                    <th>Дата</th>
                                    <th>Время</th>
                                    <th>Источник начисления</th>
                                    <th>Кол-во бонусов</th>
                                </tr>

                                <tr class="bonus_row" v-for="(data, index) in log" :key="index">
                                    <td>{{data.date}}</td>
                                    <td>{{data.time}}</td>
                                    <td>{{data.source}}</td>
                                    <td>{{data.sum}}</td>
                                </tr>

                            </table>
                        </div>

                        <div class="referal_history empty" v-else>
                            <h2>В истории пока нет записей</h2>
                        </div>
                        <div class="new_referals_header">
                            <h1>Привлечь новых пользователей</h1>
                            <button type="button" @click="referralToggle = !referralToggle" :class="referralToggle?'active choice_toggle':'choice_toggle'" id="referal_toggle"></button>
                        </div>

                        <div id="referal_types_box" :class="referralToggle?'active referal_types collapse':'referal_types collapse'">
                            <div class="type_box">
                                <div class="type_description">
                                    <h2>По ссылке</h2>
                                    <p>Все очень просто – приводите новых клиентов
                                        на <a href="#">хочу-поесть.рф</a> и получайте 50% нашей
                                        прибыли от каждого заказа.Заработать можно
                                        разными способами, выбирай один или
                                        воспользуйся всеми.Зарегистрируйся на сайте
                                        и генерируй свою реферальную ссылку, которую
                                        можно отправить друзьям, поделиться в соцсетях
                                        или опубликовать на сайте или в блоге. Ты
                                        можешь сделать реферальную ссылку на любую
                                        страницу сайта <a href="#">хочу-поесть.рф</a></p>
                                </div>

                                <div class="type_share">
                                    <div class="copy_box">
                                        <div class="copy_info">
                                            <input type="text" class="earn_input" :value="'https://хочу-поесть.рф/promocode/' + auth.users.promocode" readonly>
                                        </div>
                                        <button class="copy"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/copy.svg" alt=""></button>
                                    </div>
                                </div>

                            </div>

                            <div class="type_box">
                                <div class="type_description">
                                    <h2>По промо-коду</h2>
                                    <p>Зарегистрируйте свой личный промокод,
                                        который вы можете разместить не только в
                                        интернете, но и на любом офф-лайн носителе.</p>
                                </div>
                                <div class="type_share">
                                    <div class="copy_box">
                                        <div class="copy_info promo">
                                            <input type="text" class="earn_input" :value="auth.users.promocode" readonly>
                                        </div>
                                        <button class="copy"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/copy.svg" alt=""></button>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </section>
    </main>

</template>

<script>
import navigate from '@/pages/lk/client/navigate'
import axios from '@/router/http'
export default {
  name: 'referral',
  props: ['city', 'auth', 'basket', 'geo', 'user'],
  data () {
    return {
      pay: 'bonus',
      referralToggle: false,
      referralsToggle: false,
      bonusToggle: false,
      collapse: false,
      count: 0,
      orders: 0,
      sum: 0,
      users: [],
      log: []
    }
  },
  created () {
    axios.get('https://lk.when-hungry.com/mobile/get-money-log?uid=' + this.auth.uid).then(response => {
      this.count = response.data.count
      this.orders = response.data.orders
      this.sum = response.data.sum
      this.log = response.data.log
      this.users = response.data.users
    })
    let bonusBtn = document.getElementById('bonus_toggle')
    let bonusTable = document.getElementById('bonus_table')
    bonusBtn.addEventListener('click', function () {
      bonusBtn.classList.toggle('active')
      bonusTable.classList.toggle('active')
    })
    let referalToggle = document.getElementById('referal_toggle')
    let referalTable = document.getElementById('referal_table')
    referalToggle.addEventListener('click', function () {
      referalToggle.classList.toggle('active')
      referalTable.classList.toggle('active')
    })
  },
  methods: {
    showModal (val) {
      this.$root.modals = val
    }
  },
  components: {navigate}
}
</script>

<style scoped>

    .section.s-lk .lk_box .account_box .statistic_box .collapse_btn:before {
        content: "развернуть подробности" !important;
    }

    .section.s-lk .lk_box .account_box .statistic_box .collapse_btn.active:before {
        content: "скрыть подробности" !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/lk/client/referral.vue